<template>
    <layout class="text-white">
        <!--Page Menu is loaded by the layout-->
        <section-featured-post
            :blog-post="firstPost"
            :labels="sectionFeaturedPost.labels"
            class="mb-12 tablet:mb-10 desktop:mb-24"
        />
        <!--Container Content Section-->
        <div class="container mb-8">
            <list-post-categories
                :current-category="blogCategories.currentCategory"
                :list-title="blogCategories.listTitle"
                :post-categories="blogCategories.postCategories"
                class="mb-12 tablet:mb-10 desktop:mb-24"
            />

            <list-posts
                :blog-posts="additionalPosts"
                :labels="listPosts.labels"
            />

            <pagination
                :links="posts.links"
            />
        </div>
        <!-- <section-instagram
            :external-links="$page.externalLinks"
            :section-instagram="sectionInstagram" /> -->
        <!--Footer is loaded by the layout-->
    </layout>
</template>

<script>
import Layout from '@web/components/PageLayout';
import SectionFeaturedPost from '@web/pages/sections/BlogHome/SectionFeaturedPost';
import ListPostCategories from '@web/components/Blog/ListPostCategories';
import ListPosts from '@web/components/Blog/ListPosts';
import Pagination from '@whisper/components/pagination/Pagination';
// import SectionInstagram from '@web/pages/sections/shared/SectionInstagram';
import { get, drop } from 'lodash';

export default {
  components: {
    ListPostCategories,
    Layout,
    SectionFeaturedPost,
    ListPosts,
    Pagination,
    // SectionInstagram,
  },
  props: {
    // Shared Props from WebsiteSharedProps.php
    sectionInstagram: {
      type: Object,
      required: true,
    },

    // Page Specific Props from BlogHomePageController.php
    sectionFeaturedPost: {
      type: Object,
      required: true,
    },
    blogCategories: {
      type: Object,
      required: true,
    },
    listPosts: {
      type: Object,
      required: true,
    },
    posts: {
      type: Object,
      required: true,
    },
  },
  computed: {
    firstPost() {
      return get(this.posts, 'data.0');
    },
    additionalPosts() {
      return drop(get(this.posts, 'data', []), 1);
    },
  },
};
</script>
